import { useReactiveVar } from "@apollo/client";
import { useCallback } from "react";
import { useRouter } from "next/router";
import { isOpenPurchaseModalVar, isWakuwakuContentVar, productIdVar } from "~/components/stores/detail-product/store";
import type { VodDetailModalHref, Hrefs } from "~/const/hrefs";
import { useQueryString } from "~/hooks/use-query-string";

export const usePurchaseModalActions = () => {
  const { push, pathname } = useRouter();
  const queries = useQueryString();

  const productId = useReactiveVar(productIdVar);

  const openPurchaseModal = useCallback(async () => {
    isOpenPurchaseModalVar(true);
  }, []);

  const closePurchaseModal = useCallback(() => {
    isOpenPurchaseModalVar(false);
  }, []);

  const pushWithQueriesPurchaseModal = useCallback(
    async (contentId: string | undefined) => {
      void push(
        {
          pathname,
          query: { ...filteredPurchaseContentQuery(queries), purchaseContent: contentId },
        } as VodDetailModalHref,
        undefined,
        {
          scroll: false,
        }
      );
    },
    [queries]
  );

  const pushToBackPurchaseModal = useCallback(async () => {
    void push(
      {
        pathname,
        query: { ...filteredPurchaseContentQuery(queries) },
      } as Exclude<Hrefs, VodDetailModalHref>,
      undefined,
      { scroll: false }
    );
  }, [queries]);

  const openWakuwakuModalContent = useCallback(
    (productId: string) => {
      isWakuwakuContentVar(true);
      productIdVar(productId);
    },
    [productId]
  );
  const closeWakuwakuModalContent = useCallback(() => {
    isWakuwakuContentVar(false);
    productIdVar("");
  }, [productId]);

  const initializePurchaseModal = useCallback(() => {
    closePurchaseModal();
    closeWakuwakuModalContent();
  }, []);

  return {
    openPurchaseModal,
    closePurchaseModal,
    pushWithQueriesPurchaseModal,
    pushToBackPurchaseModal,
    openWakuwakuModalContent,
    closeWakuwakuModalContent,
    initializePurchaseModal,
  };
};

const filteredPurchaseContentQuery = (queries: ReturnType<typeof useQueryString>) => {
  const result = Object.fromEntries(
    Object.entries(queries).filter(([key]) => {
      if (key === "purchaseContent") return;
      return key;
    })
  );

  return result;
};
